:host {
  display: block;
}

smart-text {
  text-transform: uppercase;
  color: $color-action-default;
}

.button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;

  cursor: pointer;

  > .container-icon {
    transition: all .5s ease-in-out;
    transform: rotate(0deg);
  }

  > span {
    color: $color-action-default;
  }

  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.content {
  max-height: 0;
  overflow: hidden;
  transition: all .5s ease-in-out;

  &.open {
    max-height: 100vh;
  }
}

.up {
  display: flex;
  flex-direction: column-reverse;
  .container-icon {
    transform: rotate(90deg);
  }
  &:has(.open) {
    .content {
      margin-bottom: $size-space-md;
    }
    .container-icon {
      transform: rotate(-90deg);
    }
  }
}

.down {
  .container-icon {
    transform: rotate(90deg);
  }
  &:has(.open) {
    .content {
      margin-top: $size-space-md;
    }
    .container-icon {
      transform: rotate(-90deg);
    }
  }
}